import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, API } from "../../../api";
import * as dateFns from "date-fns";
import Typography from "@material-ui/core/Typography";
import { getMethod } from "../../../utils/paymentUtils";

export default function PaymentsReceived() {
  const [getReport, { data, loading }] = useLazyQuery(
    API.GET_PAYMENTS_RECEIVED,
    {
      fetchPolicy: "network-only",
    }
  );

  const [filters, setFilters] = React.useState({
    startDate: dateFns.startOfMonth(new Date()),
    endDate: dateFns.endOfMonth(new Date()),
  });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const onDateRangeChange = ({ startDate, endDate }) => {
    setFilters({ ...filters, startDate, endDate });
  };

  const getPaymentMethod = (r) => {
    const method = getMethod(r.method);
    let value = "";
    if (method === "cash") {
      value = "Cash";
    } else if (method === "cheque") {
      value = "Cheque";
    } else if (method === "both") {
      value = "Cash / Cheque";
    }
    return value;
  };

  const renderPaymentMethod = (value) => {
    let color = "";
    if (value === "Cash") {
      color = "#4CAF50";
    } else if (value === "Cheque") {
      color = "#1890FF";
    } else if (value === "Cash / Cheque") {
      color = "#FF9800";
    }
    return (
      <Typography style={{ color, fontSize: 13 }} variant="button">
        {value.toUpperCase()}
      </Typography>
    );
  };

  const getData = () => {
    if (!data) return [];
    return data.map((t) => ({ ...t, method: getPaymentMethod(t) }));
  };

  const columns = [
    {
      name: "date",
      label: "Payment Date",
      options: { align: "center", date: true },
    },
    {
      name: "paymentNo",
      label: "Payment #",
      options: { align: "center" },
    },
    {
      name: "customer",
      label: "Customer Name",
      options: { align: "left", width: 300 },
    },
    {
      name: "salesRep",
      label: "Sales Rep",
      options: { align: "center" },
    },
    {
      name: "method",
      label: "Method",
      options: {
        align: "center",
        customBodyRender: (v) => renderPaymentMethod(v),
      },
    },
    {
      name: "discount",
      label: "Discount",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "amount",
      label: "Amount",
      options: { align: "right", money: true, showTotal: true },
    },
  ];

  return (
    <Report
      title="Payments Received"
      useDateRange
      onDateRangeChange={onDateRangeChange}
      startDate={filters?.startDate}
      endDate={filters?.endDate}
      data={getData()}
      columns={columns}
      filters={[
        {
          type: "range",
          name: "range",
          label: "Payment Number Range",
          value: filters?.range,
        },
      ]}
      onFiltersChange={(e) => setFilters((x) => ({ ...x, ...e }))}
    >
      <Table
        data={getData()}
        columns={columns}
        showTotals
        isLoading={loading}
      />
    </Report>
  );
}
